export const LOADING_PREPARATION = "LOADING_PREPARATION";
export const SAVE_LOADING_PREPARATION = "SAVE_LOADING_PREPARATION";
export const GET_PREPARATION = "GET_PREPARATION";
export const FORM_FAIL_PREPARATION = "FORM_FAIL_PREPARATION";
export const PREPARATION_FAIL = "PREPARATION_FAIL";
export const LOADING_PREPARATION_BY_ID = "LOADING_PREPARATION_BY_ID";
export const GET_PREPARATION_BY_ID = "GET_PREPARATION_BY_ID";
export const SAVE_LOADING_PREPARATION_BY_ID = "SAVE_LOADING_PREPARATION_BY_ID";
